export default "__VITE_ASSET__DgWRzYQr__"